import type { Profile } from '../services/auth';

export function getUserReadableName(profile: Profile | null) {
  if (profile?.firstName && profile?.lastName) {
    return `${profile.firstName} ${profile.lastName}`;
  }
  if (profile?.firstName) {
    return profile.firstName;
  }
  if (profile?.lastName) {
    return profile.lastName;
  }
  return null;
}
